import styles from "./mhealth-studio-hero.module.scss";
import { useModal } from "../../../hooks/useModal";
import React, { useState } from "react";
import WantMoreInfo from "@/components/forms/want-more-info";
import { useTranslation } from "react-i18next";
import classNames from "classnames";

const MhealthStudioHero: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { t } = useTranslation();

  const { modal, open } = useModal({
    content: () => {
      return (
        <WantMoreInfo
          formId="mhealth-header-form-mobile"
          className={styles.moreInfoForm}
          message={true}
        />
      );
    },
  });

  return (
    <section
      aria-label={t("mhealth.hero.seo.aria-label")}
      title={t("mhealth.hero.seo.title")}
      className={styles.root}
    >
      <div className={styles.left}>
        <img
          className={styles.logo}
          alt={""}
          src={"/assets/images/mhealth/hero/mhealth-logo.png"}
        />
        <h1 className={styles.heading}>{t("mhealth.hero.heading")}</h1>
        <p className={styles.subHeading}>{t("mhealth.hero.subheading")}</p>

        <button
          className={classNames(styles.button, "mhealth")}
          type="button"
          onClick={() => open()}
        >
          {t("forms.more-info.button")}
        </button>
      </div>
      <div className={styles.right}>
        <WantMoreInfo
          formId="mhealth-header-form"
          formClassName="GA4-LeadConversion"
          className={styles.moreInfoForm}
          message={true}
        />
        {modal}
      </div>
    </section>
  );
};

export default MhealthStudioHero;
